import { get, postJson } from '../../http'

export default {
    // 获取接口数据
    getMenus(data) {
        return get('/api/sys/menus', data)
    },
    /**
     * 合作申请
     *
     * @param {*} data
     * @returns
     */
    cooperationApply(data) {
        return postJson('/lz/platform/cooapply/add', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/main/index.js